import React, { useState } from 'react';
import styled from 'styled-components';
import DynamicTable from '@atlaskit/dynamic-table';

import { iSortOrderType } from '../../../shared/UITypes/types';
import iEntityCategory from '../../../types/status/iEntityCategory';
import iPurchaseOrderDetail from '../../../types/purchases/iPurchaseOrderDetail';
import { iConfigColumn } from '../../despatchNote/shared/DispatchNote.type';
import { PO_TABLE_NAME, PO_TABLE_TEST_ID } from '../constants';
import { getHeads, getRows } from './TableHelper';

const TableWrapper = styled.div`
  th[data-testid='${PO_TABLE_NAME}-column-orderNumber--head--cell'] {
    width: 8rem;
    min-width: 8rem;
  }

  th[data-testid='${PO_TABLE_NAME}-column-supplierRef--head--cell'] {
    width: 7rem;
    min-width: 7rem;
  }

  th[data-testid='${PO_TABLE_NAME}-column-eta--head--cell'],
  th[data-testid='${PO_TABLE_NAME}-column-totalAmt--head--cell'] {
    width: 10rem;
    min-width: 6.6rem;
  }

  th[data-testid='${PO_TABLE_NAME}-column-updatedAt--head--cell'],
  th[data-testid='${PO_TABLE_NAME}-column-createdAt--head--cell'] {
    width: 11rem;
    min-width: 11rem;
  }
  th[data-testid='${PO_TABLE_NAME}-column-operation--head--cell'] {
    width: 2rem;
    min-width: 2rem;
  }
  th[data-testid='${PO_TABLE_NAME}-column-aos--head--cell'] {
    width: 10rem;
    min-width: 10rem;
  }
`;

interface iProps {
  purchaseOrders: iPurchaseOrderDetail[];
  isLoading: boolean;
  onOpenDeleteModal?: (id: string) => void;
  onSetSort: (sortStr: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: Array<iConfigColumn> | any;
  categories: Array<iEntityCategory>;
}

const PurchasesListTable = ({
  purchaseOrders,
  isLoading,
  onOpenDeleteModal,
  onSetSort,
  columns,
  categories,
}: iProps) => {
  const [sortOrder, setSortOrder] = useState<iSortOrderType>();
  const [sortKey, setSortKey] = useState<string>();

  return (
    <TableWrapper>
      <DynamicTable
        head={getHeads(columns, PO_TABLE_NAME)}
        rows={getRows(purchaseOrders, onOpenDeleteModal, columns, categories)}
        loadingSpinnerSize="large"
        isLoading={isLoading}
        onSort={
          //  eslint-disable-next-line
          (data: any) => {
            setSortKey(data.key);
            setSortOrder(data.sortOrder);
            onSetSort(`${data.key}:${data.sortOrder}`);
          }
        }
        sortKey={sortKey}
        sortOrder={sortOrder}
        testId={PO_TABLE_TEST_ID}
      />
    </TableWrapper>
  );
};

export default PurchasesListTable;
